import { IconDefinition } from '../../types';

const ThumbUp: IconDefinition = {
  name: 'thumb-up-o',
  definition: {
    viewBox: '0 0 40 40',
    pathData:
      'M36.6,15.4c-1.5-1.9-4-2-4.1-2c0,0,0,0,0,0h-9.2c1.9-3.4,2-5.3,1.8-7.3c-0.1-1.1-0.9-4.4-3-4.4c0,0,0,0-0.1,0 c-1.8,0.1-3.1,2-4.1,3.5c-0.2,0.3-0.3,0.5-0.5,0.7c-0.9,1.2-4.9,7.9-5.1,8.2l-0.5,0.9c-1-0.6-2.6-1.4-3.6-1.4c0,0,0,0,0,0 c-1.5,0-4.4,0-4.4,0c-0.2,0-0.4,0.1-0.6,0.2S3.1,14,3.1,14.2v22.2c0,0.4,0.4,0.8,0.8,0.8h4.6c1.5,0,2.8-1,3.6-1.8 c0.6,0.8,1.5,1.8,2.8,1.8h14.9c3,0,4.5-2.8,4.9-4.2l2.8-11.1C38.1,19.1,37.8,16.9,36.6,15.4z M5.4,15.8c0.9,0,1.9,0,2.7,0l0.2,0 c0.4,0,1.7,0.7,2.8,1.3v15.8C11,33,11,33.1,10.9,33.1c-0.4,0.6-1.5,1.7-2.4,1.7H5.4V15.8z M13.3,17.1c0.1-0.1,0.2-0.2,0.2-0.3 l0.9-1.6c1.1-1.9,4.2-7,4.9-8c0.2-0.2,0.3-0.5,0.5-0.8c0.4-0.5,1.4-2.1,2.1-2.4c0.3,0.4,0.7,1.5,0.8,2.2c0.2,1.6,0.3,3.2-2.1,7 c-0.3,0.5-0.3,1.1,0,1.6c0.3,0.5,0.8,0.8,1.4,0.8l10.6,0c0,0,1.5,0.1,2.3,1.1c0.9,1.1,0.7,3,0.4,4.4l-2.8,11.1c0,0-0.6,2.5-2.6,2.5 H14.9c-0.3,0-0.9-0.7-1.3-1.4c-0.1-0.2-0.2-0.3-0.3-0.5V17.1z'
  }
};

export default ThumbUp;
